/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InscriptionSuspensionDto
 */
export interface InscriptionSuspensionDto {
    /**
     * 
     * @type {number}
     * @memberof InscriptionSuspensionDto
     */
    idinscriptionSuspension?: number;
    /**
     * 
     * @type {number}
     * @memberof InscriptionSuspensionDto
     */
    idinscription?: number | null;
    /**
     * 
     * @type {Date}
     * @memberof InscriptionSuspensionDto
     */
    dateDebut?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof InscriptionSuspensionDto
     */
    dateFin?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof InscriptionSuspensionDto
     */
    remarque?: string | null;
}

/**
 * Check if a given object implements the InscriptionSuspensionDto interface.
 */
export function instanceOfInscriptionSuspensionDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function InscriptionSuspensionDtoFromJSON(json: any): InscriptionSuspensionDto {
    return InscriptionSuspensionDtoFromJSONTyped(json, false);
}

export function InscriptionSuspensionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): InscriptionSuspensionDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idinscriptionSuspension': !exists(json, 'idinscriptionSuspension') ? undefined : json['idinscriptionSuspension'],
        'idinscription': !exists(json, 'idinscription') ? undefined : json['idinscription'],
        'dateDebut': !exists(json, 'dateDebut') ? undefined : (json['dateDebut'] === null ? null : new Date(json['dateDebut'])),
        'dateFin': !exists(json, 'dateFin') ? undefined : (json['dateFin'] === null ? null : new Date(json['dateFin'])),
        'remarque': !exists(json, 'remarque') ? undefined : json['remarque'],
    };
}

export function InscriptionSuspensionDtoToJSON(value?: InscriptionSuspensionDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idinscriptionSuspension': value.idinscriptionSuspension,
        'idinscription': value.idinscription,
        'dateDebut': value.dateDebut === undefined ? undefined : (value.dateDebut === null ? null : value.dateDebut.toISOString()),
        'dateFin': value.dateFin === undefined ? undefined : (value.dateFin === null ? null : value.dateFin.toISOString()),
        'remarque': value.remarque,
    };
}

